"use strict";
const productLib = require('./product')

module.exports = {
    productLib
}; 